module.exports = __webpack_public_path__ + "images/for_companies_lp/top_sp_604501a771e84b540f9afc3e988016f2.jpg";